module.exports = __webpack_public_path__ + "static/assets/7455bbbfec01551f145bced3f729f105.png";